<template>
	<div class="offcn-teacher-disabled">
		<div class="offcn-live-invalid">
			<div class="offcn-live-messageinfo">
				<p>课程ID&nbsp;&nbsp;&nbsp;&nbsp;：{{classinfo.room_num}}</p>
				<p>课程名称：{{classinfo.room_name}}</p><p>授课时间：{{classinfo.start_time}} ~ {{classinfo.end_time}}</p>
				<p class="offcn-live-commission">该房间已被禁用，请联系相关教务人员</p>
			</div>
		</div>
	</div>
</template>

<script>
export default {
  data () {
    return {
	  classinfo: []
    }
  },
  methods: {
  	login () {
  		this.$api.GETROOM({
  			password: this.$route.query.password
		  }).then((res) => {
		  	if (res.code === 0) {
		  		this.classinfo = res.data
		  	}
		  })
  	}
  },
  mounted () {
  	this.login()
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
.offcn-teacher-disabled
{
	position: fixed;
	top: 0;
	right: 0;
	bottom: 0;
	left: 0;
	background: url('./disabled.png') no-repeat;
	background-size: 100% 100%;
}
.offcn-live-invalid
{
	width: 364px;
	height: 152px;
	position: absolute;
	top: 70%;
	left: 50%;
	transform: translate(-50%, -50%);
}
.offcn-live-messageinfo
{
	font-size: 14px;
	line-height: 26px;
	color: white;
}
.offcn-live-commission
{
	font-size: 20px;
	font-weight: 600;
	margin-top: 40px;
	text-align: center;
}
</style>



// WEBPACK FOOTER //
// src/components/offcn-teacher-disabled/disabled.vue